import { ChangeEvent, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'src/store';
import { getAllStatisticsBoleteria } from 'src/slices/events/eventAction';
import { useNavigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';
import {
  Box,
  Card,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Typography,
  Divider,
  TextField
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useBoleteriaTable } from './hookBoleteria';
import { PaginationComp } from 'src/components/Pagination/PaginationComponent';
import ModalBoleteria from './modals/ModalBoleteria';
import formatAmounts from 'src/utils/formatAmounts';

/* 
 * TODO: FILTRO POR MÉTODO DE PAGO - COMENTADO TEMPORALMENTE
 * 
 * El siguiente código relacionado con el filtrado por método de pago ha sido comentado
 * porque esta funcionalidad aún no se va a utilizar. Cuando se decida implementar:
 * 
 * 1. Descomentar las funciones: getPaymentFlagsFromStatistic, getPaymentFlagsFromFilter, 
 *    getTotalsForPaymentFilter, computeGlobalTotals
 * 2. Descomentar los imports: FilterContainerPaymentMethod, PaymentMethodFilterValue, 
 *    PaymentMethodIcon, PaymentMethod, PaymentSummaryCard
 * 3. Descomentar el estado paymentFilter y su handler
 * 4. Descomentar las cards de PaymentSummaryCard (líneas ~353-393)
 * 5. Descomentar el FilterContainerPaymentMethod en el buscador (línea ~424)
 * 6. Descomentar la columna "Payment method" en la tabla (línea ~452)
 * 7. Descomentar la lógica de filtrado por payment method (líneas ~295-320)
 * 8. Descomentar los iconos de método de pago en las filas de la tabla (líneas ~485-526)
 * 9. Actualizar el modal para pasar el initialPaymentFilter
 * 
 * IMPORTANTE: Asegurarse de que el backend también soporte el filtrado por método de pago
 * antes de descomentar esta funcionalidad.
 */

// const getPaymentFlagsFromStatistic = (statistic: any) => {
//   const detail = statistic?.detailByType ?? [];

//   let hasQr = false;
//   let hasCash = false;
//   let hasOther = false;

//   detail.forEach((item: { tktPaymentMethod?: PaymentMethod }) => {
//     const method = item.tktPaymentMethod as PaymentMethod | null;

//     if (method === 'qr') {
//       hasQr = true;
//     } else if (method === 'cash') {
//       hasCash = true;
//     } else {
//       // null o cualquier otro valor distinto de 'qr' o 'cash'
//       hasOther = true;
//     }
//   });

//   return { hasQr, hasCash, hasOther };
// };

// const getPaymentFlagsFromFilter = (
//   statistic: any,
//   paymentFilter: PaymentMethodFilterValue
// ) => {
//   const anyFilterActive = paymentFilter.qr || paymentFilter.cash || paymentFilter.other;

//   // Si no hay filtros activos, usar la lógica original
//   if (!anyFilterActive) {
//     return getPaymentFlagsFromStatistic(statistic);
//   }

//   // Si hay filtros activos, solo mostrar los métodos que están filtrados y que existen en los datos
//   const detail = statistic?.detailByType ?? [];
//   let hasQr = false;
//   let hasCash = false;
//   let hasOther = false;

//   detail.forEach((item: { tktPaymentMethod?: PaymentMethod }) => {
//     const method = item.tktPaymentMethod as PaymentMethod | null;

//     if (method === 'qr' && paymentFilter.qr) {
//       hasQr = true;
//     } else if (method === 'cash' && paymentFilter.cash) {
//       hasCash = true;
//     } else if ((method === null || (method !== 'qr' && method !== 'cash')) && paymentFilter.other) {
//       hasOther = true;
//     }
//   });

//   return { hasQr, hasCash, hasOther };
// };

// const getTotalsForPaymentFilter = (
//   statistic: any,
//   paymentFilter: PaymentMethodFilterValue
// ) => {
//   const anyFilterActive = paymentFilter.qr || paymentFilter.cash || paymentFilter.other;

//   // Sin filtro: devolvemos totales globales del statistic
//   if (!anyFilterActive) {
//     return {
//       totalQt: statistic.totalQt || 0,
//       totalAmount: statistic.totalAmount || 0
//     };
//   }

//   // Con filtro: sumamos desde detailByType solo los métodos seleccionados
//   const detail = statistic?.detailByType ?? [];
//   let totalQt = 0;
//   let totalAmount = 0;

//   detail.forEach((item: any) => {
//     const method = item.tktPaymentMethod as PaymentMethod | null;
//     const qt = item.totalQt || 0;
//     const amount = item.totalAmount || 0;

//     if (method === 'qr' && paymentFilter.qr) {
//       totalQt += qt;
//       totalAmount += amount;
//     }

//     if (method === 'cash' && paymentFilter.cash) {
//       totalQt += qt;
//       totalAmount += amount;
//     }

//     if ((method === null || (method !== 'qr' && method !== 'cash')) && paymentFilter.other) {
//       totalQt += qt;
//       totalAmount += amount;
//     }
//   });

//   return { totalQt, totalAmount };
// };

// const computeGlobalTotals = (statistics: any[]) => {
//   let totalQtGlobal = 0;
//   let totalAmountGlobal = 0;

//   let totalQtQr = 0;
//   let totalAmountQr = 0;

//   let totalQtCash = 0;
//   let totalAmountCash = 0;

//   let totalQtOther = 0;
//   let totalAmountOther = 0;

//   statistics.forEach((stat) => {
//     // Totales globales por vendedor (independientes del método de pago)
//     totalQtGlobal += stat.totalQt || 0;
//     totalAmountGlobal += stat.totalAmount || 0;

//     const detail = stat?.detailByType ?? [];

//     detail.forEach(
//       (item: {
//         tktPaymentMethod?: PaymentMethod;
//         totalQt?: number;
//         totalAmount?: number;
//       }) => {
//         const method = item.tktPaymentMethod as PaymentMethod | null;
//         const qt = item.totalQt || 0;
//         const amount = item.totalAmount || 0;

//         if (method === 'qr') {
//           totalQtQr += qt;
//           totalAmountQr += amount;
//         } else if (method === 'cash') {
//           totalQtCash += qt;
//           totalAmountCash += amount;
//         } else {
//           // null o cualquier otro valor distinto de 'qr' o 'cash'
//           totalQtOther += qt;
//           totalAmountOther += amount;
//         }
//       }
//     );
//   });

//   return {
//     totalQtGlobal,
//     totalAmountGlobal,
//     totalQtQr,
//     totalAmountQr,
//     totalQtCash,
//     totalAmountCash,
//     totalQtOther,
//     totalAmountOther
//   };
// };

// La paginación se maneja en el backend, no es necesario aplicar paginación en el frontend
// const applyPagination = (
//   users: any[],
//   page: number,
//   limit: number
// ): any[] => {
//   return users.slice(page * limit, page * limit + limit);
// };

const Results = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t }: { t: any } = useTranslation();
  const [query, setQuery] = useState<string>('');

  // TODO: FILTRO POR MÉTODO DE PAGO - COMENTADO TEMPORALMENTE
  // const [paymentFilter, setPaymentFilter] = useState<PaymentMethodFilterValue>({
  //   qr: false,
  //   cash: false,
  //   other: false
  // });

  const {
    handlePageChange,
    handleOpenDetailModal,
    openDetailModal,
    closeDetailModal,
    selectedStatistic,
    page,
    limit,
    handleLimitChange
  } = useBoleteriaTable();

  const statisticsBoleteriaData = useSelector((state) => state.events.statisticsBoleteria);
  const users = statisticsBoleteriaData?.users || [];
  const isLoadingBoleteria = useSelector((state) => state.events.isLoadingBoleteria);
  const activeEvent = useSelector((state) => state.events.activeEvent);
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedQuery(query);
    }, 500);
  
    return () => clearTimeout(timeoutId);
  }, [query]);
  // Cargar datos cuando cambie changeBoleteria, página o límite (manteniendo el query actual)
  useEffect(() => {
    if (!activeEvent) {
      navigate('/dashboard/management/events/list');
      return;
    }
  
    const offset = page * limit;
  
    dispatch(
      getAllStatisticsBoleteria(
        activeEvent.id,
        offset,
        limit,
        debouncedQuery
      )
    );
  }, [activeEvent?.id, page, limit, debouncedQuery]);

  const handleQueryChange = (
    event: ChangeEvent<HTMLInputElement>
  ): void => {
    event.persist();
    setQuery(event.target.value);
  };

  // Usar directamente los usuarios del backend (ya vienen filtrados y paginados)
  // El backend maneja la búsqueda y la paginación
  const paginatedStatisticsBoleteria = users;

  if (isLoadingBoleteria) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <SuspenseLoader />
      </Box>
    );
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent={{ xs: 'center', sm: 'space-between' }}
        pb={3}
      ></Box>
        {/* TODO: FILTRO POR MÉTODO DE PAGO - Cards de totales globales - COMENTADO TEMPORALMENTE */}
        {/* <Box
          p={2}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2
          }}
        >
          <PaymentSummaryCard
            title={t('Tickets sold by ticket office')}
            totalLabel={t('Total')}
            totalQuantity={totalQtGlobal}
            totalAmount={formatAmounts(totalAmountGlobal, t)}
            accentColor="#1A75FF"
          />

          <PaymentSummaryCard
            title={t('Tickets sold by QR')}
            totalLabel={t('Total')}
            totalQuantity={totalQtQr}
            totalAmount={formatAmounts(totalAmountQr, t)}
            accentColor="#1A75FF"
          />

          <PaymentSummaryCard
            title={t('Tickets sold by cash')}
            totalLabel={t('Total')}
            totalQuantity={totalQtCash}
            totalAmount={formatAmounts(totalAmountCash, t)}
            accentColor="#44D600"
          />

          <PaymentSummaryCard
            title={t('Other payment methods')}
            totalLabel={t('Total')}
            totalQuantity={totalQtOther}
            totalAmount={formatAmounts(totalAmountOther, t)}
            accentColor="#636161"
          />
        </Box> */}
      <Card>
        {/* Buscador */}
        <Box
          p={2}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'space-between',
            gap: 2
          }}
        >
          <TextField
            sx={{ m: 0, flex: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchTwoToneIcon />
                </InputAdornment>
              )
            }}
            onChange={handleQueryChange}
            placeholder={t('Search by first or last name...')}
            value={query}
            size="small"
            fullWidth
            margin="normal"
            variant="outlined"
          />

          {/* TODO: FILTRO POR MÉTODO DE PAGO - COMENTADO TEMPORALMENTE */}
          {/* <FilterContainerPaymentMethod
            value={paymentFilter}
            onChange={setPaymentFilter}
          /> */}
        </Box>

        <Divider />
        {paginatedStatisticsBoleteria.length === 0 ? (
          <>
            <Typography
              sx={{ py: 10 }}
              variant="h3"
              fontWeight="normal"
              color="text.secondary"
              align="center"
            >
              {t('No records of statistical data were found in')}{' '}
              "{t('Ticket office')}".
            </Typography>
          </>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t('Seller')}</TableCell>
                    <TableCell align="right">{t('Quantity')}</TableCell>
                    {/* TODO: FILTRO POR MÉTODO DE PAGO - Columna Payment method - COMENTADO TEMPORALMENTE */}
                    {/* <TableCell align="center" sx={{ width: 150 }}>
                      {t('Payment method')}
                    </TableCell> */}
                    <TableCell align="right">{t('Amount')}</TableCell>
                    <TableCell align="center">
                      {t('See detail')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedStatisticsBoleteria.map((statistic) => {
                    // TODO: FILTRO POR MÉTODO DE PAGO - Lógica de filtrado - COMENTADO TEMPORALMENTE
                    // const { hasQr, hasCash, hasOther } =
                    //   getPaymentFlagsFromFilter(statistic, paymentFilter);
                    // const { totalQt, totalAmount } = getTotalsForPaymentFilter(statistic, paymentFilter);

                    // const iconsToShow = [];
                    // if (hasQr) iconsToShow.push('qr');
                    // if (hasCash) iconsToShow.push('cash');
                    // if (hasOther) iconsToShow.push('other');

                    // Usar los totales directamente del statistic (sin filtro de payment method)
                    const totalQt = statistic.totalQt || 0;
                    const totalAmount = statistic.totalAmount || 0;

                    return (
                      <TableRow hover key={statistic.id}>
                        <TableCell>
                          <Typography noWrap variant="subtitle2">
                            {`${statistic.name} ${statistic.lastname}`}
                          </Typography>
                        </TableCell>
                        <TableCell align='right'>
                          <Typography noWrap variant="subtitle2">
                            {totalQt}
                          </Typography>
                        </TableCell>

                        {/* TODO: FILTRO POR MÉTODO DE PAGO - Iconos de método de pago - COMENTADO TEMPORALMENTE */}
                        {/* <TableCell align="center">
                          {iconsToShow.length === 0 && (
                            <Typography noWrap variant="subtitle2">
                              -
                            </Typography>
                          )}

                          {iconsToShow.length > 0 && (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                columnGap: 0.5
                              }}
                            >
                              {iconsToShow.map((method) => {
                                if (method === 'other') {
                                  return (
                                    <Box
                                      key="other"
                                      sx={{
                                        width: 24,
                                        height: 24,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}
                                    >
                                      <CardTravelIcon
                                        sx={{
                                          fontSize: 20,
                                          color: '#636161'
                                        }}
                                      />
                                    </Box>
                                  );
                                }
                                return <PaymentMethodIcon key={method} method={method as PaymentMethod} />;
                              })}
                            </Box>
                          )}
                        </TableCell> */}

                        <TableCell align='right'>
                          <Typography noWrap variant="subtitle2">
                            {formatAmounts(totalAmount, t)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleOpenDetailModal(statistic);
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <PaginationComp
              page={page}
              count={statisticsBoleteriaData?.total || 0}
              limit={limit}
              handleLimitChange={(newLimit) => {
                handleLimitChange(newLimit);
                // El useEffect se encargará de cargar los datos con el nuevo límite y el query actual
              }}
              handlePageChange={(newPage) => {
                handlePageChange(newPage);
                // El useEffect se encargará de cargar los datos con la nueva página y el query actual
              }}
            />
            <ModalBoleteria
              open={openDetailModal}
              onClose={closeDetailModal}
              statistic={selectedStatistic}
              initialPaymentFilter={{ qr: false, cash: false, payment_link: false, other: false }}
            />
          </>
        )}
      </Card>
    </>
  );
};

export default Results;
